export default __webpack_public_path__ + "28a47c6b51edff63da15692715894a54.obj";